import { SelectOption } from "global";
import { DeclineReasonOption, SubmissionDeclineReasonCategory } from "../types";

export const getSubmissionDeclineReasonsOptions = (creditSubmissionDeclineReasons: any[]): DeclineReasonOption[] => {
  return creditSubmissionDeclineReasons
    .filter(o => o.isActive)
    .map(csdr => {
      return {
        label: csdr.label,
        value: csdr.creditSubmissionDeclineReasonId,
        category: csdr.category,
      };
    });
};

export const getAddEditDeclineReasonCategoryOptions = (): SelectOption[] => {
  return Object.keys(SubmissionDeclineReasonCategory).map(key => {
    return {
      label: SubmissionDeclineReasonCategory[key as keyof typeof SubmissionDeclineReasonCategory],
      value: SubmissionDeclineReasonCategory[key as keyof typeof SubmissionDeclineReasonCategory],
    };
  });
};
